import { mutationTypes } from '@/core/constants'
import paginacaoListagem from '@/core/store/default/paginacaoListagem'

export default {
	[mutationTypes.ATA.PESQUISA.ADESAO.SET_PAGINACAO_PESQUISA_LISTAGEM](state, paginacao) {
		state.paginacao = paginacao
	},
	[mutationTypes.ATA.PESQUISA.ADESAO.RESET_PAGINACAO_PESQUISA_LISTAGEM](state) {
		state.paginacao = paginacaoListagem(['seq'], 5, 'ASC')
	},
	[mutationTypes.ATA.PESQUISA.ADESAO.RESETAR_PAGINA_PESQUISA_LISTAGEM](state) {
		state.paginacao.page = 1
	},
}
